import React, { useEffect, useState } from "react";
import "./styles/index.scss";
import Popup from "../index";
import Button from "../../common/forms/button";
import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  currencyFormat,
  currencyRoundUp,
  toISOString,
} from "../../../helpers/utils";
import CalendarIcon from "../../common/icons/calendarIcon";

type WireReceivedPopupProps = {
  open: boolean;
  onClose: () => void;
  wireName: string;
  wireAmount: number;
  existingValue?: Date;
  onMark: (dateString: string) => void;
};

const WireReceivedPopup = (props: WireReceivedPopupProps) => {
  const { open, onClose, wireName, wireAmount, existingValue, onMark } = props;

  const [value, setValue] = useState<string>(toISOString(new Date()));
  const [isOpenDatePicker, setIsOpenDatePicker] = useState(false);

  const wireAmountFormatted = currencyFormat(currencyRoundUp(wireAmount));

  useEffect(() => {
    if (existingValue) {
      setValue(toISOString(existingValue));
    }
  }, [existingValue]);

  return (
    <React.Fragment>
      <Popup isOpen={open} onClosePopup={onClose}>
        <div className="wire-amount-popup-container">
          <i className="close-icon" aria-hidden="true" onClick={onClose} />
          <div className="title">Wire Date</div>
          <div
            data-testid="modal-wire-legal-entity-name"
            className="description"
          >
            from {wireName}
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className="date-picker-container">
              {/* //TODO: The KeyboardDatePicker is deprecated and should be replaced https://mui.com/material-ui/guides/pickers-migration/ */}
              <KeyboardDatePicker
                className="variable-text"
                label="Date received"
                value={value && toISOString(new Date(value))}
                onChange={(dateValue) => setValue(toISOString(dateValue))}
                views={["date"]}
                fullWidth={true}
                format="MMMM d, yyyy"
                keyboardIcon={<CalendarIcon />}
                inputVariant="outlined"
                InputProps={{ readOnly: true }}
                onClick={(e) => {
                  setIsOpenDatePicker(true);
                  e.stopPropagation();
                  e.preventDefault();
                }}
                onClose={() => {
                  setIsOpenDatePicker(false);
                }}
                open={isOpenDatePicker}
                autoOk={true}
              />
            </div>
          </MuiPickersUtilsProvider>
          <div data-testid="modal-wire-amount" className="wire-amount">
            expected exact wire amount {wireAmountFormatted}
          </div>
          <Button
            data-testid="button-mark-wire-received"
            type="primary"
            onClick={() => {
              onMark(value);
            }}
          >
            mark as received
          </Button>
        </div>
      </Popup>
    </React.Fragment>
  );
};

export default WireReceivedPopup;
